import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

export const isInvalidPaintConfig = ({ data, configId }) => {
  if (data && !data.product?.paintDetails?.colorId) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `ConfigId ${configId} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }
  return null;
};

export const isPaintReorderPIPDisabled = (disablePaintReorderPIPFS) => {
  if (disablePaintReorderPIPFS) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: 'Page disabled',
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }
  return null;
};

export const isInvalidCanonical = ({ data, configId, disableCanonicalRedirect, path }) => {
  let normalizedPath = path.replace(/^\/p\/paint\/config\/.*?\//, '/p/');
  const { canonicalUrl } = data?.product?.identifiers || {};

  if (canonicalUrl && !disableCanonicalRedirect && normalizedPath !== canonicalUrl) {
    return {
      shouldRedirect: true,
      httpCode: HTTP_CODE.PERM_REDIRECT,
      redirectPath: canonicalUrl.replace('/p/', `/p/paint/config/${configId}/`),
      description: 'redirected for canonical'
    };
  }
  return null;
};
